import { Component } from '@angular/core';
import { SettingsService } from '../../../../core/settings.service';
import { CheckoutService } from '../../../../checkout/checkout.service';
import { BreakpointService } from '../../../../breakpoint/breakpoint.service';

@Component({
    selector: 'app-checkout-step-delivery',
    template: `
        <section class="flow-step">
            <section class="flow-step__header">
                <h1 class="h4">
                    {{ 'checkout.delivery_step____headline' | translate }}
                </h1>
                <p>{{ 'checkout.delivery_step____description' | translate }}</p>
            </section>

            <div
                class="grid-spacing-normal"
                *ngIf="settingsService.get() | async as ss"
                [ngClass]="{ 'grid-spacing-large': breakpointService.matchBreakpoint(1024) | async }"
            >
                <app-rich-text [html]="ss.checkout.checkoutDeliveryStep"></app-rich-text>
            </div>

            <section class="flow-step__content" *ngIf="checkoutService.getCheckoutData() | async as cd">
                <app-tab-group [initialActiveIndex]="cd.delivery ? 1 : 0">
                    <app-tab [label]="'checkout.delivery_step____pickup_tab____title' | translate">
                        <app-checkout-step-delivery-tab-pickup> </app-checkout-step-delivery-tab-pickup>
                    </app-tab>
                    <app-tab [label]="'checkout.delivery_step____delivery_tab____title' | translate" [isActive]="true">
                        <app-checkout-step-delivery-tab-delivery> </app-checkout-step-delivery-tab-delivery>
                    </app-tab>
                </app-tab-group>
            </section>
        </section>
    `,
})
export class CheckoutStepDeliveryComponent {
    constructor(public checkoutService: CheckoutService, public settingsService: SettingsService, public breakpointService: BreakpointService) {}
}
